import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceStatus } from '../enums';
import { InvoiceStatusProviderService } from '../providers';

@Pipe({
  name: 'invoiceStatus',
})
export class InvoiceStatusPipe implements PipeTransform {
  private readonly provider = inject(InvoiceStatusProviderService);

  public transform(status: InvoiceStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
